import { css } from "@emotion/react"

export const priceFilterStyles = {
	container: css`
		padding: 0.75rem 0;
	`,

	sliderContainer: css`
		padding: 1rem 0.5rem 0;

		.MuiSlider-root {
			color: #0b75e1;
		}

		.MuiSlider-thumb {
			width: 20px;
			height: 20px;
			background-color: #fff;
			border: 2px solid #0b75e1;

			&:hover,
			&.Mui-focusVisible {
				box-shadow: 0 0 0 8px rgba(11, 117, 225, 0.16);
			}
		}

		.MuiSlider-track {
			height: 4px;
			border-radius: 2px;
		}

		.MuiSlider-rail {
			height: 4px;
			border-radius: 2px;
			background-color: #e5e7eb;
		}

		.MuiSlider-valueLabel {
			background-color: #0b75e1;
			font-size: 0.75rem;
			padding: 0.25rem 0.5rem;
		}
	`,

	sliderLabels: css`
		display: flex;
		justify-content: space-between;
		margin-top: 0.5rem;
		font-size: 0.875rem;
		color: #6b7280;
		font-weight: 500;
	`,

	customRangeContainer: css`
		margin-top: 1.5rem;
	`,

	customRangeLabel: css`
		font-size: 0.875rem;
		color: #6b7280;
		margin-bottom: 0.75rem;
	`,

	inputsRow: css`
		display: flex;
		gap: 0.5rem;
		align-items: center;
		box-sizing: border-box;
		padding: 0;
	`,

	applyButton: css`
		background-color: #0b75e1 !important;
		color: white;
		border-radius: 4px;
		width: 24px;
		height: 44px;
		padding: 0;
		min-width: 24px;
		margin-bottom: 0.125rem;

		&:hover {
			background-color: #0961c0 !important;
			color: white;
		}

		svg {
			width: 20px;
			height: 20px;
		}
	`,

	numericInput: css`
		border-color: #d1d5db;
		width: 100%;
		height: 44px;
		box-sizing: border-box;
		padding: 10px;
	`,
}
